<template>
  <v-card>
    <v-card-text>
      <v-row>
        <v-col sm="12" md="6" lg="6">
          <!-- <img
            class="card-image"
            :src="getImage"
            alt=""
          /> -->
          <v-carousel hide-delimiters height="280">
            <v-carousel-item
              v-for="(item, i) in getImage"
              :key="i"
              :src="item.src"
            ></v-carousel-item>
          </v-carousel>
        </v-col>
        <v-col sm="12" md="6" lg="6">
          <div>
            <div v-text="item.name" class="text-h5"></div>
            <div v-text="item.description" class="text-subtitle1"></div>
            <!-- <v-rating
              color="#F2A006"
              empty-icon="mdi-star-outline"
              full-icon="mdi-star"
              half-icon="mdi-star-half-full"
              hover
              length="5"
              size="14"
              :value="4"
              dense
              readonly
            >
            </v-rating> -->
          </div>
          <div class="mt-5">
            <v-row>
              <v-col sm="6">
                <div class="card-item">
                  <img
                    src="@/assets/icons/user.svg"
                    class="icon"
                    alt=""
                  />&nbsp;
                  <span
                    class="text-subtitle-2"
                    v-text="'Seats ' + item.seat"
                  ></span>
                </div>
                <div class="card-item">
                  <img
                    src="@/assets/icons/star.svg"
                    class="icon"
                    alt=""
                  />&nbsp;
                  <span
                    class="text-subtitle-2"
                    v-text="'Sleeps ' + item.seat"
                  ></span>
                </div>
                <div class="card-item">
                  <img src="@/assets/icons/van.svg" class="icon" alt="" />&nbsp;
                  <span class="text-subtitle-2" v-text="'2WD*'"></span>
                </div>
                <div
                  class="card-item"
                  style="
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                  "
                >
                  <img
                    src="@/assets/icons/space.svg"
                    class="icon"
                    alt=""
                  />&nbsp;
                  <span
                    class="text-subtitle-2"
                    v-text="'Living Space Air Conditioning*'"
                  ></span>
                </div>
              </v-col>
              <!-- <v-col sm="6">
                <div>
                  <img src="@/assets/icons/space.svg" class="icon" alt="">&nbsp;
                  <span
                    class="text-subtitle-2"
                    v-text="'Free Cancellation'"
                  ></span>
                </div>
              </v-col> -->
            </v-row>
          </div>
        </v-col>
        <!-- <v-col sm="12" md="3" lg="3" class="d-flex align-center justify-center"> -->
        <!-- <div class="d-flex align-center justify-center flex-column">
            <div v-text="'ESTIMATED TOTAL'" class="text-subtitle-2"></div>
            <div
              v-text="'$' + item.price"
              class="text-h5 font-weight-bold mt-3"
            ></div>
            <div v-text="'plus tax'" class="text-subtitle-2"></div>
            <v-btn link text color="accent">
              <span class="text-subtitle-2 mt-3">Terms and Conditions</span>
            </v-btn>
          </div> -->
        <!-- </v-col> -->
      </v-row>
      <v-row>
        <v-col>
          <span class="headline"> Amenities </span>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          sm="6"
          md="3"
          v-for="amenity in item.amenities"
          :key="amenity.id"
          class="d-flex align-center"
          cols="12"
        >
          <img
            :src="amenity.icon"
            height="30px"
            width="30px"
            :alt="amenity.name"
          />&nbsp;
          <span class="text-subtitle-2" v-text="amenity.name"></span>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    checked: true,
  }),
  computed: {
    getImage() {
      return this.item.vehicle_images || [];
    },
  },
};
</script>

<style scoped lang="scss">
.card-image {
  width: 100%;
  height: auto;
}

// trashed
.card {
  display: flex;
  justify-content: space-between;
  background: var(--light);
  padding: 15px 25px;
  box-shadow: 0 12px 12px #166b825f;

  &-seprator {
    border: 1px solid var(--grey);
  }
  &-offer {
    font-size: 1.5rem;
    font-weight: bold;
    text-decoration: line-through;
  }
  &-discount {
    font-size: 1.5rem;
    font-weight: bold;
    color: var(--secondary-color);
  }
  &-selling {
    font-size: 2.4rem;
    font-weight: bold;
    color: var(--primary-color);
  }
  &-interval {
    font-size: 0.8rem;
    font-weight: bold;
    color: var(--primary-color);
  }
  &-item {
    display: flex;
    align-items: center;
    margin: 5px 0;
  }
}
.icon {
  width: 20px;
  pointer-events: none;
}
</style>
